import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { EnquiriesEntity } from "../../enquiries/entites/enquiries";
import { EnquiryProdctsEntity } from "../../enquiries/entites/enquiry-products";

@Entity("cost_sheet")
export class CostSheetEntity {
    @PrimaryGeneratedColumn('increment',{
        name:"cost_sheet_id"
    }) 
    costSheetId: number;

    @Column('int',{
        name:'variant_id',
        nullable:false
    })
    variantId: number

    @Column('decimal',{
        name:'quantity',
        nullable:false,
        precision:10,scale:3,
        unsigned:true,
    })
    quantity:number

    @Column('int',{
        name:'yield',
        nullable:false
    })
    yield: number

    @Column('int',{
        name:'pack_count',
        nullable:false
    })
    packCount: number

    @Column('int',{
        name:'rm_count',
        nullable:false
    })
    rmCount: number

    @Column('decimal',{
        name:'rm_rate',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    rmRate: number

    @Column('decimal',{
        name:'rm_cost',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    rmCost: number

    @Column('decimal',{
        name:'mfg_cost',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    mfgCost: number

    @Column('decimal',{
        name:'freight_and_forward_exp',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    freightAndForwardExp: number

    @Column('decimal',{
        name:'sale_commission',
        nullable:false,
        precision:10,scale:3,
        unsigned:true,
    })
    saleCommission: number

    @Column('decimal',{
        name:'pack_material_cost',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    packMaterialCost: number

    @Column('decimal',{
        name:'total_expenses',
        nullable:false,
        precision:10,scale:2,
        // unsigned:true,
    })
    totalExpenses: number

    @Column('decimal',{
        name:'cost_of_sales_inr',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    costOfSalesInr: number

    @Column('decimal',{
        name:'exchange_rate',
        nullable:false,
        precision:10,scale:3,
        unsigned:true,
    })
    exchangeRate: number

    @Column('decimal',{
        name:'cost_of_sales_usd_kg',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    costOfSalesUSDKG: number

    @Column('decimal',{
        name:'cost_of_sales_usd_lb',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    costOfSalesUSDLB: number

    @Column('decimal',{
        name:'prev_confirmed_price',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    prevConfirmedPrice: number

    @Column('decimal',{
        name:'quote_price',
        nullable:true,
        precision:10,scale:2,
        unsigned:true,
    })
    quotePrice: number

    @Column('decimal',{
        name:'buyer_offer_price',
        nullable:true,
        precision:10,scale:2,
        unsigned:true,
    })
    buyerOfferPrice: number

    
    @Column('boolean',{
        name:'quote_status',
        nullable:true
    })
    quoteStatus: boolean

    @Column('decimal',{
        name:'net_pl_on_buyer_price',
        nullable:true,
        precision:10,scale:2,
        // unsigned:true,
    })
    netPlOnBuyerPrice: number

    @Column('decimal',{
        name:'incentives',
        nullable:true,
        precision:10,scale:2,
        unsigned:true,
    })
    incentives: number

    @Column('decimal',{
        name:'final_profit_loss',
        nullable:true,
        precision:10,scale:2,
        // unsigned:true,
    })
    finalProfitLoss: number

    @Column('decimal',{
        name:'pl_percentage',
        nullable:true,
        precision:10,scale:3,
        // unsigned:true,
    })
    plPercentage: number

    @Column('decimal',{
        name:'contribution_percentage',
        nullable:true,
        precision:10,scale:3,
        // unsigned:true,
    })
    contributionPercentage: number

    @Column('decimal',{
        name:'sale_cost_added_rmrate',
        nullable:true,
        precision:10,scale:2,
        unsigned:true,
    })
    saleCostAddedRmrate: number

    @Column('decimal',{
        name:'sale_cost_reduced_rmrate',
        nullable:true,
        precision:10,scale:2,
        // unsigned:true,
    })
    saleCostReducedRmrate: number

    @Column('decimal',{
        name:'added_rm_rate',
        nullable:true,
        precision:10,scale:2,
        unsigned:true,
    })
    addedRmRate: number

    @Column('decimal',{
        name:'reduced_rm_rate',
        nullable:true,
        precision:10,scale:2,
        unsigned:true,
    })
    reducedRmRate: number

    @Column('decimal',{
        name:'sales_commision_per',
        nullable:false,
        precision:10,scale:3,
        unsigned:true,
    })
    salesCommissionPercentage:number

    @Column('decimal',{
        name:'production_cost',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    productionCost: number

    @Column('decimal',{
        name:'fixed_cost',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    fixedCost: number

    @Column('decimal',{
        name:'market_rate',
        nullable:false,
        precision:10,scale:2,
        unsigned:true,
    })
    marketRate: number
    @Column('decimal',{
        name:'adcvd_per_val',
        nullable:true,
        precision:10,scale:2,
    })
    adCvdPerValue: number//anti dumping duty and CVD percentages value
    @Column('decimal',{
        name:'total_sale_cost',
        nullable:true,
        precision:10,scale:2,
        unsigned:true,
    })
    totalSaleCost: number

    @Column('int',{
        name:'ad_per',//Anti dumping duty percentage
        nullable:true
    })
    adPercentage: number
    @Column('int',{
        name:'cvd_per',//CVD percentage
        nullable:true
    })
    cvdPercentage: number

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    @ManyToOne(() => EnquiriesEntity,enquiries =>enquiries.costSheet )
    @JoinColumn({name:'enquiry_id'})
    enquiryEntity:EnquiriesEntity

    @ManyToOne(() => EnquiryProdctsEntity,endProd =>endProd.costSheet )
    @JoinColumn({name:'enquiry_product_id'})
    enquiryProductEntity:EnquiryProdctsEntity
}